module.exports = __webpack_public_path__ + "static/media/265442.29718455.jpg";